// extracted by mini-css-extract-plugin
export default {"unit":"8px","bookAndHoldAckRow":"XqFNND23W_MDgmHATTzY","override":"EwSIHWgqqmYs_xxDiJgp"};